import React from "react";
import { Calendar, CalendarCheck, Server, AlertTriangle } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

export const ScheduleKeyMetricsRow: React.FC<any> = ({ data }) => {
  const metricsData = [
    {
      title: "Next Run",
      count: data?.nextExecutionDate || "N/A",
      trendSummary: `in ${data?.nextRunInDays} days`,
      icon: <Calendar className="h-8 w-8 text-blue-500" />,
      tooltip: "Planned date for the next execution of this schedule.",
    },
    {
      title: "Assets in Scope",
      count: data?.scheduleAssets?.length || 0,
      trendSummary: "",
      icon: <Server className="h-8 w-8 text-green-500" />,
      tooltip: "Number of assets linked to this schedule. Clicking lets you view asset details.",
    },
    {
      title: "Open Service Orders",
      count: data?.openServiceOrders?.count || 0,
      trendSummary: `${data?.openServiceOrders?.overdue} Overdue`,
      icon: <AlertTriangle className="h-8 w-8 text-orange-500" />,
      tooltip: "Total number of service orders generated from this schedule that are not yet completed. Red indicator shows overdue ones.",
    },
    {
      title: "Last Run Completed",
      count: data?.lastModifiedDate || "N/A",
      trendSummary: data?.lastCompletedOnTime ? "On-Time" : "Delayed",
      icon: <CalendarCheck className="h-8 w-8 text-purple-500" />,
      statusColor: data?.lastCompletedOnTime,
      tooltip: "The most recent successful execution date of the schedule.",
    },
  ];

  return (
    <div className="space-y-3">
      <div>
        <p className="page-title">Schedule Overview</p>
        <p className="page-subtitle">
          Key performance indicators and upcoming activities
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {metricsData.map((metric, index) => (
          <QuickStatsCard
            key={index}
            title={metric.title}
            count={metric.count}
            trendSummary={metric.trendSummary}
            icon={metric.icon}
            tooltip={metric.tooltip}
          />
        ))}
      </div>
    </div>
  );
};
